import { aludraApi } from 'api/axios'

// Returns active branches (Status = 1) enabled for the dispatch-before-invoice
// flow (billing flow picking). Supports search by name and pagination.
export const searchActiveBillingFlowPickingBranches = async ({
  companyId,
  search = '',
  pageNumber = 1,
  pageSize = 20,
}) => {
  const { data } = await aludraApi.post(
    '/mdl11/billingFlowPickingBranch/search/active',
    { companyId, search, pageNumber, pageSize }
  )
  return data
}

// Manually retries a dispatch document whose Oracle picking request failed
// after the backend's automatic retries were exhausted, without making the
// seller re-enter the dispatch data. Expects the full dispatch document
// (SalesDocumentInfo) as the payload.
export const retryDispatchPickingRequest = async dispatchDocument => {
  const { data } = await aludraApi.post(
    '/integrationvad/PickingOracleRetry',
    dispatchDocument
  )
  // Aludra services can return HTTP 200 with a functional failure in the
  // body (e.g. Status.Code 500), which Axios wouldn't otherwise reject on.
  if (data?.Status?.Code !== 200) {
    throw new Error(
      data?.Status?.Message ||
        'RIGHT_SELECTION_MODAL.DISPATCH_FLOW.CONNECTION_ERROR'
    )
  }
  return data
}
